import { useState, useRef } from 'react';

import useGroupedDropdownOptions from './useGroupedDropdownOptions';
import useGroupedDropdownMenuPosition from './useGroupedDropdownMenuPosition';

function useGroupedDropdown({ groups, value, isFilterable, usePortal, isTopProp }) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [highlightedIndex, setHighlightedIndex] = useState(-1);

  const wrapperRef = useRef(null);
  const portalRef = useRef(null);
  const menuRef = useRef(null);

  const { flatOptions, selectedOption, filteredGroups, flatFilteredOptions, hasOptions } = useGroupedDropdownOptions(
    groups,
    value,
    searchQuery,
    isFilterable,
  );

  const menuPosition = useGroupedDropdownMenuPosition(wrapperRef, dropdownOpen, usePortal, isTopProp);

  const highlightedOption = flatFilteredOptions[highlightedIndex] ?? null;
  const isTop = usePortal ? menuPosition?.bottom != null : isTopProp;

  return {
    dropdownOpen,
    setDropdownOpen,
    searchQuery,
    setSearchQuery,
    highlightedIndex,
    setHighlightedIndex,
    wrapperRef,
    portalRef,
    menuRef,
    flatOptions,
    selectedOption,
    filteredGroups,
    flatFilteredOptions,
    hasOptions,
    highlightedOption,
    menuPosition,
    isTop,
  };
}

export default useGroupedDropdown;
